import { IconArrow } from '../atoms/Icons';

function getContrastColor(bgHex) {
  if (!bgHex) return '#000000';
  // Convert HEX → RGB
  const hex = bgHex.replace('#', '');
  const r = parseInt(hex.substring(0, 2), 16) / 255;
  const g = parseInt(hex.substring(2, 4), 16) / 255;
  const b = parseInt(hex.substring(4, 6), 16) / 255;

  const srgb = [r, g, b].map((c) =>
    c <= 0.03928 ? c / 12.92 : Math.pow((c + 0.055) / 1.055, 2.4)
  );

  const L = 0.2126 * srgb[0] + 0.7152 * srgb[1] + 0.0722 * srgb[2];

  // Contrast ratios with white & black
  const contrastWhite = 1.05 / (L + 0.05);
  const contrastBlack = (L + 0.05) / 0.05;

  return contrastWhite > contrastBlack ? '#FFFFFF' : '#000000';
}

export default function PromotionCard({
  promotion,
  onClick,
  venderClass,
  promotionClass,
  typeBadge,
  detailsLabel,
  showActionArea = true,
  isActive = false,
}) {
  const vendorColor = promotion.vendorColor || '';
  const vendorTextColor = getContrastColor(vendorColor);

  const vendorStyle = {
    backgroundColor: vendorColor,
    color: vendorTextColor,
  };

  return (
    <div
      onClick={() => onClick(promotion)}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault(); // prevent scroll on space
          onClick(promotion);
        }
      }}
      role="button"
      tabIndex={0}
      className={`grid grid-cols-[1fr_auto] md:items-center items-end mb-2 gap-4 py-4 lg:px-6 md:px-5 px-4 rounded-[14px] ${isActive ? 'bg-[#ECECEC]' : 'bg-white'} shadow-[-2px_2px_20px_rgba(0,0,0,0.06)] cursor-pointer focus:outline-none focus-visible:ring-2 focus-visible:ring-cyan-500 focus-visible:ring-offset-2 relative ${promotionClass}`}
    >
      <div className="min-w-0 flex flex-col md:flex-row md:items-center gap-y-1.5 md:gap-y-0 gap-x-5 ">
        <h2 className="xl:text-xl lg:text-lg text-[15px] leading-[1.2em] font-semibold tracking-tight text-[#323232] overflow-hidden text-ellipsis [display:-webkit-box] [-webkit-line-clamp:2] [-webkit-box-orient:vertical]">
          {promotion.offerText}
        </h2>
        <div className="flex items-center gap-2 flex-wrap">
          {promotion.vendor && (
            <span
              className={`items-center w-fit rounded-full px-3 py-2 text-xs font-semibold whitespace-nowrap overflow-hidden min-w-20 text-center text-ellipsis block ${venderClass}`}
              style={vendorStyle}
            >
              {promotion.vendor}
            </span>
          )}
          {typeBadge}
        </div>
      </div>

      {showActionArea && (
        <div className="flex items-center xl:gap-3 gap-2 lg:p-1 lg:pt-1 sm:pt-2">
          {detailsLabel && (
            <span className="xl:text-sm text-[13px] md:block hidden text-[#3232322] font-medium max-w-[90px] leading-[1.14em] text-right whitespace-normal">
              {detailsLabel.split(' ').map((word, index) => (
                <span key={index} className="block">
                  {word}
                </span>
              ))}
            </span>
          )}
          <span
            aria-hidden="true"
            className="grid xl:h-9 xl:w-9 w-6 h-6 place-items-center rounded-full bg-[#00EAFD]"
          >
            <IconArrow className="xl:w-5 w-3" />
          </span>
        </div>
      )}
    </div>
  );
}
